import React from "react";

import { ButtonView } from "common/views/button/Button.view";
import Icon from "common/views/icon/Icon";
import { TextInputVariant, TextInputView } from "common/views/textInput/TextInput.view";
import PickLabels from "core/components/label/PickLabels";
import { IPanelProps, Panel } from "core/decorators/Panel";
import styled from "styled-components";
import labelProvider from "./RefineText.labels";
import RefineTextPanelConfig from "./RefineTextPanelConfig";

interface IRefineTextPanelState {
	value: string;
}

const SearchForm = styled.form`
	display: flex;
	align-items: center;
`;

@Panel({
	id: "refine-text",
	configClass: RefineTextPanelConfig,
	pageParams: true,
	labelProvider
})
class RefineTextPanel extends React.PureComponent<IPanelProps<RefineTextPanelConfig>, IRefineTextPanelState> {

	public constructor(props: IPanelProps<RefineTextPanelConfig>) {
		super(props);

		const { config = {} as RefineTextPanelConfig, pageParams = {} } = props;

		this.state = {
			value: pageParams[config.paramName || "query"] || ""
		};
	}

	public render() {
		const { config, pageParams } = this.props;

		const active = pageParams[config.paramName || "query"];
		const value = active ? this.state.value : "";

		return (
			<SearchForm onSubmit={this.onSubmit}>
				<PickLabels labels={{'search.placeholder': config.placeholder || "Search Keywords"}}>
					{
						(messages) => (
							<TextInputView
								viewKey="searchbar"
								variant={TextInputVariant.SEARCH}
								value={this.state.value}
								onChange={this.onChange}
								placeholder={messages['search.placeholder']}
								style={{flexGrow: 1}}
								ariaLabel={config.placeholder || "search bar"}
							/>
						)
					}
				</PickLabels>
				{active ? (
					<ButtonView onClick={this.onClear} viewKey="clear">
						<Icon icon="cross" />
					</ButtonView>
				) : (
					<ButtonView onClick={this.onSubmit} viewKey="go">
						<Icon icon="search" />
					</ButtonView>
				)}
			</SearchForm>
		);
	}

	private onChange = (value: string) => {
		this.setState({value}, () => {
			if (this.props.config.autoSubmit) {
				this.onSubmit();
			}
		});
	}

	private onClear = () => {
		const { actions, config } = this.props;
		const name = config.paramName || "query";

		this.setState({value: ""}, () => {
			actions.removePageParam(name);
		});
	}

	private onSubmit = (e?: any) => {
		if (e) {
			e.preventDefault();
		}
		const { actions, config } = this.props;

		const name = config.paramName || "query";

		if (!!this.state.value) {
			actions.pushPageParams({key: name, value: this.state.value}, {key: 'pageNumber', value: 0});
		} else {
			actions.removePageParam(name);
		}
	}
}



// WEBPACK FOOTER //
// ./src/panels/refineText/RefineText.panel.tsx